
export default {
    getProficiencia(state) {
        return state.proficiencia
    },
    getProficiencias(state) {
        return state.proficiencias
    }
}